export const FAVORITES_PROCESSING_START = 'FAVORITES_PROCESSING_START'
export const FAVORITES_PROCESSING_END = 'FAVORITES_PROCESSING_END'
export const SET_TIMEOUT_ID = 'SET_TIMEOUT_ID'
export const SET_PROMOTION_CODE_AMOUNT = 'SET_PROMOTION_CODE_AMOUNT'
export const UPLOAD_PROGRESS = 'UPLOAD_PROGRESS'
export const UPDATE_PROJECT_RECORD = 'UPDATE_PROJECT_RECORD'
export const SET_LIVE_ASSIGNEES = 'SET_LIVE_ASSIGNEES'
export const SET_ASSIGNEES_REQUESTS = 'SET_ASSIGNEES_REQUESTS'
